import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Resets window scroll to the top on every pathname change EXCEPT
 * browser back/forward navigations (pop-state) — those should restore
 * the previous scroll position, which the browser does for us by default
 * as long as we don't overwrite it.
 *
 * Anchor navigation (location.hash present) is also respected — we only
 * scroll-to-top when the path itself changes and there's no hash.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    const navType = useNavigationType();

    useEffect(() => {
        if (hash) return;                 // let native #anchor scroll happen
        if (navType === "POP") return;     // let browser restore prior scroll on back/forward
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash, navType]);

    return null;
}
